<template>
  <div class="p-t-4">
    <button
      v-if="activeCreator && $route.path.indexOf('archive') === -1 && activeCreator.id === getLoginData.data.user.id && !exportPdf"
      class="w-full blue-button fz13 fw500 p-y-1.5"
      @click="onAddCargo"
    >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.3333 7.33332H8.66668V2.66662C8.66668 2.2987 8.36798 2 7.99994 2C7.63202 2 7.33332 2.2987 7.33332 2.66662V7.33332H2.66662C2.2987 7.33332 2 7.63202 2 7.99994C2 8.36798 2.2987 8.66668 2.66662 8.66668H7.33332V13.3333C7.33332 13.7013 7.63202 14 7.99994 14C8.36798 14 8.66668 13.7013 8.66668 13.3333V8.66668H13.3333C13.7013 8.66668 14 8.36798 14 7.99994C14 7.63202 13.7013 7.33332 13.3333 7.33332Z" fill="white"/></svg>
      Create new cargo
    </button>

    <div class="m-t-4 shadow-table border border-dark-gray rounded-lg flex" v-for="(cargo, i) in getEditableCargos" :key="i">
      <div class="blocked-changes" v-if="$route.path.indexOf('archive') >= 0 || activeCreator.id !== getLoginData.data.user.id"></div>
      <cargo-port-detail :detail="cargo" :exportPdf="exportPdf"/>
      <cargo-port-loading :detail="cargo" :exportPdf="exportPdf"/>
      <cargo-port-discharging :detail="cargo" :exportPdf="exportPdf"/>
    </div>

    <div class="m-t-4 shadow-table border border-dark-gray rounded-lg overflow-hidden">
      <div class="blocked-changes" v-if="$route.path.indexOf('archive') >= 0 "></div>
      <div class="bg-gray-dark cargo_list__table_row cargo_list__table_row_head text-gray-text">
        <div class="p-y-1 p-l-3 p-r-1" v-tooltip.top="'Cargo'">Cargo</div>
        <div class="p-y-1 p-l-3 p-r-1" v-tooltip.top="'Quantity'">Quantity</div>
        <div class="p-y-1 p-l-3 p-r-1" v-tooltip.top="'Freight'">Freight</div>
        <div class="p-y-1 p-l-3 p-r-1" v-tooltip.top="'Load Port'">Load Port</div>
        <div class="p-y-1 p-l-3 p-r-1" v-tooltip.top="'Rate/Days'">Rate/Days</div>
        <div class="p-y-1 p-l-3 p-r-1" v-tooltip.top="'Terms'">Terms</div>
        <div class="p-y-1 p-l-3 p-r-1" v-tooltip.top="'Turn time'">Turn time</div>
        <div class="p-y-1 p-l-3 p-r-1" v-tooltip.top="'Water'">Water</div>
        <div class="p-y-1 p-l-3 p-r-1" v-tooltip.top="'Season'">Season</div>
        <div class="p-y-1 p-l-3 p-r-1" v-tooltip.top="'Disch. Port'">Disch. Port</div>
        <div class="p-y-1 p-l-3 p-r-1" v-tooltip.top="'Rate/Days'">Rate/Days</div>
        <div class="p-y-1 p-l-3 p-r-1" v-tooltip.top="'Terms'">Terms</div>
        <div class="p-y-1 p-l-3 p-r-1" v-tooltip.top="'Turn time'">Turn time</div>
        <div class="p-y-1 p-l-3 p-r-1" v-tooltip.top="'Water'">Water</div>
        <div class="p-y-1 p-l-3 p-r-1" v-tooltip.top="'Season'">Season</div>
        <div class=""></div>
      </div>

      <cargo-row
        v-for="row in cargoList"
        :key="row.id"
        :row="row"
        :list="cargoList"
        :editedCargoId="null"
        @on-delete="onDeleteRow(row.id)"
        @on-select="onSelectRow(row.id)"
      />
    </div>

    <div class="p-t-6"></div>
  </div>
</template>

<script>
import cargoRow from '@/components/calc/cargoRow'
import cargoPortDetail from '@/components/calc/cargoPortDetail'
import cargoPortLoading from '@/components/calc/cargoPortLoading'
import cargoPortDischarging from '@/components/calc/cargoPortDischarging'
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex'
export default {
  props: {
    exportPdf: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    cargoRow,
    cargoPortDetail,
    cargoPortLoading,
    cargoPortDischarging
  },
  data() {
    return {
      editedCargoId: null,
      emptyCargo: {
        tab: null,
        ballast_voyage: false,
        cargo_class: null,
        quantity_min: null,
        quantity_max: null,
        quantity_mt: null,
        quantity_percentage: null,
        freight: null,
        cg_comm: 3.75,
        stowage_factor_m: null,
        stowage_factor_ft: null,
        extra_cargo_costs: null,
        loading_wk_cranes: true,
        loading_port_name: null,
        loading_rate_type: 'RATE',
        loading_rate: null,
        loading_terms: null,
        loading_turn_time: '12',
        loading_liner: null,
        loading_draft: null,
        loading_water_density: 'Salt water (1,25)',
        loading_seasonal_mark: 'summer',
        discharging_wk_cranes: true,
        discharging_port_name: null,
        discharging_rate_type: 'RATE',
        discharging_rate: null,
        discharging_terms: null,
        discharging_turn_time: '12',
        discharging_liner: null,
        discharging_draft: null,
        discharging_water_density: 'Salt water (1,25)',
        discharging_seasonal_mark: 'summer',
        loading_port: null,
        discharging_port: null
      },
      cargoList: [],
    }
  },
  computed: {
    ...mapState({
      activeCreator: state => state.tabs.activeCreator,
    }),
  ...mapGetters(['getLoginData']),
    getEditableCargo() {
      return this.cargoList?.find(el=>el.id == this.editedCargoId)
    },
    getEditableCargos() {
      return this.cargoList;
    },
  },
  methods: {
    ...mapActions(['axiosGetCalcCargo', 'axiosPostCalcCargo', 'axiosDeleteCalcCargo']),
    ...mapMutations(['showLoad', 'hideLoad']),
    async onAddCargo() {
      let newCargo = JSON.parse(JSON.stringify(this.emptyCargo))
      newCargo.tab = +this.$route.params.id
      let rasponceCargo = await this.axiosPostCalcCargo(newCargo)
      this.cargoList.push(rasponceCargo)
      this.editedCargoId = rasponceCargo.id
    },
    async onDeleteRow(id) {
      await this.axiosDeleteCalcCargo(id)
      let delIndex = this.cargoList.findIndex(el=>el.id == id)
      if(delIndex >= 0)
        this.cargoList.splice(delIndex, 1)

      if(this.cargoList.length){
        this.editedCargoId = this.cargoList[this.cargoList.length-1].id
      }else{
        this.onAddCargo()
      }
    },
    onSelectRow(id) {
      this.editedCargoId = id
    },
    async loadCargo() {
      this.showLoad()
      this.cargoList = []

      let cargoList = await this.axiosGetCalcCargo(this.$route.params.id)
      if(cargoList.length){
        this.cargoList = cargoList
        this.editedCargoId = this.cargoList[this.cargoList.length-1].id
      }else{
        await this.onAddCargo()
      }
      this.hideLoad()
    }
  },
  /* beforeMount() {
    this.loadCargo()
  },
  beforeRouteUpdate(to, from, next) {
    next()
    this.loadCargo()
  } */
}
</script>

<style lang="scss">
.cargo_list__table_row{
  display: flex;
  >div{
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    box-sizing: border-box;
    &:not(:last-child){
      border-right: 1px solid var(--color-gray-text);
    }
    &:nth-child(1){width: 11.1386%;}/* 180 */
    &:nth-child(2){width: 5.5693%;}/* 90 */
    &:nth-child(3){width: 6.1881%;}/* 100 */
    &:nth-child(4){width: 10.5198%;}/* 170 */
    &:nth-child(5){width: 5.5693%;}/* 90 */
    &:nth-child(6){width: 5.3218%;}/* 86 */
    &:nth-child(7){width: 4.3317%;}/* 70 */
    &:nth-child(8){width: 5.9406%;}/* 96 */
    &:nth-child(9){width: 5.9406%;}/* 96 */
    &:nth-child(10){width: 10.5198%;}/* 170 */
    &:nth-child(11){width: 5.5693%;}/* 90 */
    &:nth-child(12){width: 5.3218%;}/* 86 */
    &:nth-child(13){width: 4.3317%;}/* 70 */
    &:nth-child(14){width: 5.9406%;}/* 96 */
    &:nth-child(15){width: 5.9406%;}/* 96 */
    &:nth-child(16){
      width: 30px;
      flex-shrink: 0;
      font-size: 0;
    }
  }
}
.cargo_list__table_row_head{
  >div{
    font-size: 13px;
  }
}

.default_select__in_calc{
  .multiselect__input, .multiselect__single{
    margin-bottom: 3px;
  }
  .multiselect__tags{
    min-height: 28px;
    padding-top: 4px;
    border: none;
    background-color: transparent;
  }
}
</style>

<style lang="scss" scoped>
  .calc_compare__vessel_row >div {
    word-wrap: break-word;
    word-break: break-all;
  }
  .shadow-table {
    position: relative;
  }
  .blocked-changes {
    position: absolute;
    z-index: 50;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }
</style>